const QuickEasyProcessSection = () => {
  return (
    <>
      <div className="quick-easy-process desktop">
        <div className="wrapper">
          <h2> Quick & Easy Process:</h2>
          <div className="shield-box">1</div>
          <h3>Search</h3>
          <div className="shield-box">2</div>
          <h3>File</h3>
          <div className="shield-box">3</div>
          <h3>Protect</h3>
        </div>
      </div>
      <div className="quick-easy-process mobile">
        <div className="wrapper">
          <h2> Quick & Easy Process:</h2>
          <div className="shield-box-wrapper">
            <div className="shield-box">1</div>
            <h3>Search</h3>
          </div>
          <div className="arrow"></div>
          <div className="shield-box-wrapper">
            <div className="shield-box">2</div>
            <h3>File</h3>
          </div>
          <div className="arrow"></div>
          <div className="shield-box-wrapper">
            <div className="shield-box">3</div>
            <h3>Protect</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuickEasyProcessSection;
